import React, { useEffect, useState } from 'react'
import ReactMultiSelect from '@kenshooui/react-multi-select'
import { ArrowBackIos, NotificationsOutlined } from '@material-ui/icons'
import Loading from 'components/Loading'
import { Formik } from 'formik'
import { Card, Col, Container, Row, Form, Button, Modal, Alert } from 'react-bootstrap'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Link, useHistory } from 'react-router-dom'
import ResalesRequestService from 'services/resales-request'
import { maskDocument } from 'helpers/document'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from 'react-select'
import NewNotification from 'services/new_notification-request'
import Swal from 'sweetalert2'
import SAlert from '../../helpers/alert';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from 'date-fns/locale';
registerLocale('pt-br', ptBR)

export default function () {
  const history = useHistory()
  const [isPremium, setIsPremium] = useState("")
  const [loading, setLoading] = useState(false)
  const [companiesOptionsSelect, setCompaniesOptionsSelect] = useState([])  
  const [isSaving, setIsSaving] = useState(false)
  const [showAlertSuccess, setShowAlertSuccess] = useState(false)
  const [showModalAddLink, setShowModalAddLink] = useState(false)  
  //const [link, setLink] = useState("/link")
  const [titleLink, setTitleLink] = useState("")
  const [hrefLink, setHrefLink] = useState("")

  const values = {
    companies: [],
    type: null,
    priority: 0,
    title: "",
    content: "",
    scheduled_for_enable: false,
    scheduled_for: new Date()
  }

  function handleSubmit(values) {
    function convertJsDateToMysqlDatetime(jsDate) {
      // Get the ISO string in UTC
      const isoString = jsDate.toISOString();
    
      // Extract the YYYY-MM-DDTHH:mm:ss part
      const datetimePart = isoString.slice(0, 19);
    
      // Replace 'T' with a space
      const mysqlDatetimeString = datetimePart.replace('T', ' ');
    
      return mysqlDatetimeString;
    }
    setIsSaving(true)
    const formData = new FormData()
    formData.append('type', values.type)
    formData.append('priority', values.priority)
    formData.append('title', values.title)
    formData.append('content', values.content)
    if(values.scheduled_for_enable){
      formData.append('scheduled_for', convertJsDateToMysqlDatetime(values.scheduled_for))
    }
    values.companies.forEach((c, i) => formData.append(`companies[${i}]`, c.id))

    NewNotification.store(formData)
      .then(() => {
        SAlert.success('Notificacao Enviada!').then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            history.push('/notifications')
          }
        });
      })
      .finally(() => setIsSaving(false))
  }

  useEffect(() => {
    fetchCompanies()
  }, [isPremium])

  async function fetchCompanies() {
    setLoading(true)
    const { data } = await ResalesRequestService.getToNotifications({
      params: {
        is_premium: isPremium
      }
    })

    const list = data.map(item => {
      return {
        id: item.company_id,
        label: `${!item.alias ? item.name : item.alias} - ${maskDocument(item.document)}`
      }
    })

    setCompaniesOptionsSelect(list)

    setLoading(false)
  }

  const modalAddLinkComponent = (values, setFieldValue) => {
    return (
      <Modal
        centered
        size='sm'
        show={showModalAddLink}
        onHide={() => setShowModalAddLink(false)}
      >
        <Modal.Header closeButton>Adicionar Link</Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Título:</Form.Label>
            <Form.Control as="input" value={titleLink} onChange={e => setTitleLink(e.target.value)} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Link:</Form.Label>
            <Form.Control as="input" value={hrefLink} onChange={e => setHrefLink(e.target.value)} />
          </Form.Group>
          <Button onClick={() => {
            var link = `<a target='_blank' href='${hrefLink}'>${titleLink}</a>`
            const newMessage = values.content.replace(titleLink, link)
            //setMessage(`${message} ${link}`)
            //setFieldValue('content', newMessage)
            values.content = newMessage
            setShowModalAddLink(false)
            setTitleLink("")
            setHrefLink("")
          }}>Adicionar</Button>
        </Modal.Body>
      </Modal>
    )
  }

  return (
    <Container>
      <Row>
        <Col md="2">
          <Link to="/notifications" className="link-back d-flex">
            <ArrowBackIos className="icon-title icon-back" />
            <h6 className="font-13 mt-3">Voltar</h6>
          </Link>
        </Col>
        <Col md="12">
          <div className='d-flex'>
            <NotificationsOutlined className="icon-title" />
            <h5 className="title-dashboard">Enviar Notificação</h5>
          </div>
        </Col>
        <Col md="12">
          <Card className='shadow bg-white rounded m-2'>
            <Card.Body>
              <Formik
                initialValues={values}
                onSubmit={handleSubmit}
              >
                {({ handleSubmit, handleChange, errors, values, setFieldValue }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col>
                          <Alert
                            show={showAlertSuccess && !isSaving}
                            variant="success"
                          >
                            Notificação Enviada!
                          </Alert>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <Form.Label>Revendas:</Form.Label>
                            <Form.Control
                              className="col-4"
                              as="select"
                              value={isPremium}
                              onChange={({ target }) => setIsPremium(target.value)}
                            >
                              <option selected disabled>Classificação</option>
                              <option value="">Todos</option>
                              <option value="5">ScanSource Select</option>
                              {/* <option value="1">Elite</option>
                              <option value="3">ScanCash</option> */}
                            </Form.Control>
                            <hr />
                            <ReactMultiSelect
                              loading={loading}
                              loaderRenderer={() => (
                                <div style={{ margin: 'auto auto' }}>
                                  <Loading page />
                                </div>
                              )}
                              messages={{
                                searchPlaceholder: "Procurar...",
                                noItemsMessage: "Sem Revendas...",
                                noneSelectedMessage: "Nada Selecionado",
                                selectedMessage: "Selecionado(s)",
                                selectAllMessage: "Selecionar Todas",
                                clearAllMessage: "Limpar Tudo"
                              }}
                              selectedItems={values.companies}
                              items={companiesOptionsSelect}
                              onChange={selected => {
                                setFieldValue('companies', selected)
                                //setResales(selected)
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Tipo:</Form.Label>
                            <Select
                              placeholder="Selecione..."
                              onChange={({ value }) => {
                                setFieldValue('type', value)
                              }}
                              options={[
                                { value: 1, label: 'Notificação' },
                                { value: 2, label: 'Aviso' },
                              ]}
                            />
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>
                              <Form.Check
                                type={"checkbox"}
                                label={"Agendar para:"}
                                onChange={(e) => {
                                  setFieldValue('scheduled_for_enable', e.target.checked)
                                }}
                              />
                            </Form.Label>
                            <DatePicker
                              disabled={!values.scheduled_for_enable}
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeIntervals={15}
                              timeCaption="time"
                              dateFormat="dd/MM/yyyy H:mm"
                              selected={!values.scheduled_for_enable?undefined:values.scheduled_for}
                              onChange={(e) => {
                                setFieldValue('scheduled_for', e)
                              }}
                              className="form-control"
                              locale="pt-br"
                            />
                          </Form.Group>
                        </Col>
                        {values.type == 1 ? (
                          <Col md="4">
                            <Form.Group>
                              <Form.Label>Prioridade:</Form.Label>
                              <Select
                                placeholder="Selecione..."
                                onChange={({ value }) => {
                                  setFieldValue('priority', value)
                                }}
                                options={[
                                  { value: 0, label: 'Mais Baixa' },
                                  { value: 1, label: 'Baixa' },
                                  { value: 2, label: 'Alerta' },
                                  { value: 3, label: 'Urgente' }
                                ]}
                              />
                            </Form.Group>
                          </Col>
                        ) : (<></>)}
                        <Col md="12">
                          <Form.Group className="mb-3">
                            <Form.Label>Título:</Form.Label>
                            <Form.Control
                              type="text"
                              value={values.title}
                              onChange={({ target }) => setFieldValue('title', target.value)}
                            />
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Row>
                            <Col>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Mensagem: {' '}
                                  <span className='ml-1 font-weight-light text-info font-italic'>
                                    <FontAwesomeIcon icon={faInfoCircle} /> Caso queira adicionar um link, selecione uma palavra e pressione o botão direito do mouse.
                                  </span>
                                </Form.Label>
                                <Form.Control
                                  id="message-box"
                                  as="textarea"
                                  value={values.content}
                                  onChange={({ target }) => setFieldValue('content',target.value)}
                                  onContextMenu={(ev) => {
                                    ev.preventDefault()
                                    const textSelected = window.getSelection().toString().trim()
                                    if (textSelected != "") {
                                      setTitleLink(textSelected)
                                      setShowModalAddLink(true)
                                    }
                                  }}
                                  rows={6}
                                />
                              </Form.Group>
                            </Col>
                            <Col>
                              <Form.Group>
                                <Form.Label>Preview:</Form.Label>
                                <p className='form-control message-box-preview' dangerouslySetInnerHTML={{ __html: `${values.content}`.replaceAll("\r\n","<br>") }} />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                        <Col md="12">
                          <Button disabled={loading} type='submit'>Enviar</Button>
                        </Col>
                        {modalAddLinkComponent(values, setFieldValue)}
                      </Row>
                    </Form>
                  )
                }}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}